import { render, staticRenderFns } from "./SidebarContent.vue?vue&type=template&id=19b0ceeb&scoped=true"
import script from "./SidebarContent.vue?vue&type=script&lang=js"
export * from "./SidebarContent.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/sidebar-content.css?vue&type=style&index=0&id=19b0ceeb&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b0ceeb",
  null
  
)

export default component.exports